<template>
  <div class="transaction">
    <h4>{{$t('recenttransaction')}}</h4>
    <ul v-if="history.length">
      <li v-for="(item, index) in history" :key="index">
        <div class="history-details">
          {{roundDown(item.gold_amount, 4)}}gm {{$t('gold')}} {{item.category}}
          <span
            class="transaction-price"
          >{{item.bank_amount ? `Rs ${Number(item.bank_amount) + Number( item.hasOwnProperty('wallet') ? item.wallet : 0 )}`: ''}}</span>
          <span
            class="fail"
            v-if="item"
          >{{item.transaction_status === "FAIL" ? `[${item.transaction_status}]` : null}}</span>
          <div class="trnstn_invoice_wrap" v-if="item.transaction_status === 'SUCCESS'">
            <div class="transaction_id">
              {{$t('transactionid')}} :
              <span>{{item.tx_id}}</span>
            </div>
            <div class="invoice_id">
              {{$t('invoiceid')}} :
              <span>{{item.invoice_id}}</span>
            </div>
          </div>
        </div>
        <div class="transaction-time">{{getLongFormattedDate(item.record_created_at, "en-IN")}}</div>
      </li>
       <div class="more_data">
      <span v-if="(hideMoreButton) && (history.length)">No more history</span>
      <Button class="more-btn" v-if="!hideMoreButton" @click="moreTransactionList">+ more</Button>
      </div>
    </ul>
    <span class="gold-panel nohistory" v-if="!history.length">{{$t('nohistoryfound')}}</span>
    <div class="loader" v-if="loading">
      <img src="https://cdn.mall91.com/9ca91a3c-b750-4f95-854b-15588473cc97.gif" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { toaster, getLongFormattedDate , roundDown} from "../utils/helper";

export default {
  name: "Transaction",
  components: {
    
  },
  data() {
    return {
      history: [],
      loading: false,
      pagination: 0,
      hideMoreButton:false
    };
  },

  computed: {
    ...mapGetters(["isUserAuthorized"])
  },

  methods: {
    roundDown,
    getLongFormattedDate,
    moreTransactionList(){
       this.loading = !this.loading;
       this.$store
      .dispatch({ type: "getTransactions", payload: this.pagination })
      .then(data => {
        this.loading = !this.loading;
        this.history = this.history.concat(data.data.data);
       if (data.data.data.length) {
         this.pagination = this.pagination + 5;
        }
        else{
          this.hideMoreButton=true;
        }
      })
      .catch(err => {
        this.loading = !this.loading;
        toaster(this, this.$t("somethingwentwrong"), "top-left", 2000);
      });
    },
  },
  mounted() {
    this.moreTransactionList()
  }
};
</script>